import jwt from '@/auth/jwt/useJwt'
import { computed, ref } from '@vue/composition-api'
import Vue from 'vue'

export default function Roles() {
  const route = 'roles'
  const role = ref({ permissions: [] })

  const formattedRole = computed(() => ({
    ...role.value,
    name: `${role.value.displayName}-${Vue.prototype.$orgId * 1}`,
    organizationId: Vue.prototype.$orgId,
  }))

  const indexRequest = params => jwt.axiosIns.get(route, { params }).then(res => res).catch(() => [])

  const indexByOrganizationIdRequest = (organizationId, params) => jwt.axiosIns.get(`role/organization/${organizationId}`, { params }).then(res => res).catch(() => [])

  const showRequest = id => jwt.axiosIns.get(`${route}/${id}`).then(res => res).catch(() => [])

  const storeRequest = () => jwt.axiosIns.post(route, formattedRole.value).then(res => res)

  const updateRequest = () => jwt.axiosIns.put(`${route}/${role.value.id}`, formattedRole.value).then(res => res)

  const destroyRequest = id => jwt.axiosIns.delete(`${route}/${id}`).then(res => res)

  return {
    role, indexRequest, indexByOrganizationIdRequest, showRequest, storeRequest, updateRequest, destroyRequest,
  }
}
